import { useTypedSelector } from "../hooks";
import { ToastItem } from "../slices/toastSlice";

export const useToasts = (): ToastItem[] => {
  const state = useTypedSelector(({ toast }) => toast);
  return Object.values(state);
};
